import React from "react";
import DepartureTable from "./DepartureTable";
import { useDeparture } from "./useDeparture";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const DepartureViewContent = () => {
  const { t } = useTranslation("common");
  const { stats } = useDeparture();
  const { user } = useSelector((state) => state.userReducer);
  const userRole = user?.attributes?.userRole;
  const titleByRole = {
    0: "",
    1: t("Departure"),
    2: t("Departure"),
    3: `${t("Departure")} - ${
      user?.attributes?.storekeeper?.data?.attributes?.entrepot?.data
        ?.attributes?.name ?? ""
    }`,
    4: "",
  };

  return (
    <div className="">
      <p className="text-blue bold f30 quickSand">{titleByRole[userRole]}</p>
      <div className="d-flex flex-wrap gap-4 mb-5">
        {stats.map((stat) => (
          <div
            className="d-flex flex-column p-4 flex-1 max-w-300px"
            style={{
              backgroundColor: stat.color,
              borderRadius: "10px",
            }}
          >
            <p className="f20 sBold text-white mb-2">{stat.label}</p>
            <p className="f18 sBold text-white">{stat.value}</p>
          </div>
        ))}
      </div>
      <DepartureTable />
    </div>
  );
};

export default DepartureViewContent;
